import cn from 'classnames';

import Button from 'components/common/Button';
import Text from 'components/common/Text';

const searchTerms = ['Oven Ready', 'Chicken', 'Keto'];

const MenuSearchDropdown = ({ handleSearch, searchControlRefs }) => {
  return (
    <div className="flex flex-col rounded-lg border border-solid border-[#BABABA] bg-white-100 p-4 shadow-md">
      <Text className="textMd mb-2 text-charcoal-90">Popular</Text>
      <ul aria-label="Popular recipe searches" className="m-0 list-none p-0">
        {searchTerms.map((searchTerm, index) => (
          <li key={searchTerm}>
            <Button
              type="button"
              ref={element => {
                searchControlRefs.current[index + 1] = element;
              }}
              variation="Ghost"
              className={cn(
                'mb-2 w-full px-4 py-1 text-left text-[#232323]',
                '!transition-none last:mb-0',
                'hover:bg-green-50',
                'focus:!border-green-50 focus:!bg-green-50 focus:outline-none'
              )}
              onClick={() => handleSearch({ params: { searchTerm: searchTerm } })}
            >
              {searchTerm}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

MenuSearchDropdown.propTypes = {
  handleSearch: PropTypes.func,
  searchControlRefs: PropTypes.shape({ current: PropTypes.array }).isRequired,
};

export default MenuSearchDropdown;
